import { formatMoney } from "@/components/restaurant/finance/constants";
import { COURIER_TYPE, DISPATCHER_TYPE, initials, isCourier, missingFields, payingText } from "./teamLogic";

const PAYING_LABEL_KEYS = { 1: "by_month", 2: "by_percent", 3: "by_delivery" };

/** Tekstovi korisnika dostavne firme (uloga, status, plaćanje, šta nedostaje). Lokalizovani, pa nisu u čistoj logici. */
export default {
  methods: {
    memberName(user) {
      return `${this.toLatin(user.name)} ${this.toLatin(user.lastname)}`.trim();
    },
    memberInitials(user) {
      return this.toLatin(initials(user));
    },
    isCourier,
    roleLabel(user) {
      if (user.type === COURIER_TYPE) return this.$t("delivery_team.role.courier");
      if (user.type === DISPATCHER_TYPE) return this.$t("delivery_team.role.dispatcher");
      return user.type || "";
    },
    statusText(user) {
      if (user.suspended) {
        return user.reason ? this.$t("delivery_team.status.suspended_reason", { reason: this.toLatin(user.reason) }) : this.$t("delivery_team.status.suspended");
      }
      return this.$t(user.active ? "active" : "inactive");
    },
    payTypeLabel(ptype) {
      return PAYING_LABEL_KEYS[ptype] ? this.$t(PAYING_LABEL_KEYS[ptype]) : "";
    },
    /** "2,00 KM", "15,00 %" ili "" kad plaćanje nije uneseno */
    payAmountText(user, currency = "KM") {
      return payingText(user, { currency, number: (value) => formatMoney(value, "") });
    },
    /** "2,00 KM po dostavi" */
    payFullText(user, currency = "KM") {
      const amount = this.payAmountText(user, currency);
      return amount ? `${amount} · ${this.payTypeLabel(user.ptype).toLowerCase()}` : "";
    },
    missingText(user) {
      return missingFields(user)
        .map((key) => this.$t(`delivery_team.missing.${key}`))
        .join(", ");
    },
    dateText(iso) {
      return iso ? this.localeDate(iso) : "";
    },
  },
};
